import { useEffect, useRef, useState } from "react"

export function useComponentVisible(initialIsVisible: boolean) {
	const [isComponentVisible, setIsComponentVisible] = useState(
		initialIsVisible as boolean
	)
	const ref = useRef(null)

	const handleHideDropdown = (event: KeyboardEvent) => {
		if (event.key === "Escape") {
			setIsComponentVisible(false)
		}
	}

	const handleClickOutside = (event: Event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			setIsComponentVisible(false)
		}
	}

	useEffect(() => {
		document.addEventListener("keydown", handleHideDropdown, true)
		document.addEventListener("click", handleClickOutside, true)
		return (): void => {
			document.removeEventListener("keydown", handleHideDropdown, true)
			document.removeEventListener("click", handleClickOutside, true)
		}
	})

	return { ref, isComponentVisible, setIsComponentVisible }
}
